import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';

import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { AgmCoreModule } from '@agm/core';

import { FuseSharedModule } from '@fuse/shared.module';
import { FuseWidgetModule } from '@fuse/components/widget/widget.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FuseConfirmDialogModule } from '@fuse/components';
import { MatDialogModule } from '@angular/material/dialog';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { RoleComponent } from './role-list/role-list.component';
import { RoleEntryComponent } from './role-entry/role-entry.component';
import { RoleService } from './role.service';
import { TranslateModule } from '@ngx-translate/core';
import { AssignPermissionToRoleComponent } from '../permission/assign-permission-to-Role/assign-permission-to-Role.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';


const routes = [
  {
      path     : 'role',
      component: RoleComponent
  },
  {
    path     : 'role/add',
    component: RoleEntryComponent
  },
  {
    path: 'role/edit/:id',
    component: RoleEntryComponent
  },
  {
    path: 'role/:roleId/permission',
    component: AssignPermissionToRoleComponent
  }
];
@NgModule({
  
  declarations: [
    RoleComponent,
    RoleEntryComponent   
  ],
  imports: [
    MatButtonModule,
    MatChipsModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatPaginatorModule,
    MatRippleModule,
    MatSelectModule,
    MatSortModule,
    MatSnackBarModule,
    MatTableModule,
    MatTabsModule,
    MatTooltipModule,
    NgxChartsModule,
    FuseConfirmDialogModule,
    MatDialogModule,
    AgmCoreModule.forRoot({
        apiKey: 'AIzaSyD81ecsCj4yYpcXSLFcYU97PvRsE_X8Bx8'
    }),
    RouterModule.forChild(routes),
    TranslateModule,
    CommonModule,
    FuseSharedModule,
    FuseWidgetModule,
    BrowserAnimationsModule,
    DragDropModule,
    MatProgressSpinnerModule,
    NgxSkeletonLoaderModule
   
  ],
  providers:[
    RoleService     
  ]
  
})
export class RoleModule { }
